import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-combo',
  templateUrl: './combo.component.html',
  styleUrls: ['./combo.component.css']
})
export class ComboComponent implements OnInit {
  @Input() loading = false;
  @Input() required = false;
  @Input() disabled = false;
  @Input() disabledInput = null;
  @Input() label = '';
  @Input() size = '4';

  constructor() { }

  ngOnInit() {
  }
}
